var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{attrs:{"id":"body-wrap"}},[_c('LayoutHeader',{attrs:{"title":"변화의 은평","color":"bg-green"}},[_c('ul',{staticClass:"category_list",attrs:{"slot":"navigator"},slot:"navigator"},[_c('li',[_vm._v("홈")]),_c('li',[_vm._v("변화의 은평")])])]),_c('Biz')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }